<template>
  <div
    class="Manage-system-content-main"
    :class="{ 'Manage-system-content-main-mobile': isMobile }"
  >
    <div class="headers">
      贝壳已建立自上而下的数据安全及隐私保护组织架构，由最高决策层组成信息安全与数据合规委员会，负责数据隐私相关的战略制定和重要问题决策理。
    </div>
    <div class="main">
      <ManageSystemContentItem
        v-for="item in dataList"
        :key="item.id"
        :data="item"
      ></ManageSystemContentItem>
      <div class="main-tips">
        自上而下形成从平台、品牌、店东、经纪人的对个人信息保护的网络，全方位多角色通力维护您的隐私权利。
      </div>
    </div>
    <div class="circle"></div>
  </div>
</template>
<script>
export default {
  name: "ManageSystemContent",
  data() {
    return {
      dataList: [
        {
          title: "信息安全与数据合规委员会",
          oneName: "制定数据隐私相关的战略",
          twoName: "决策重要问题",
          id: 1,
        },
        {
          title: "数据安全管理小组",
          oneName: "制定公司重大风险治理方案",
          twoName: "协同各方推进数据安全与个人隐私合规治理",
          id: 2,
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.Manage-system-content-main {
  margin-top: calc($multiple * 28px);
  position: relative;
  .headers {
    height: calc($multiple * 36px);
    font-size: calc($multiple * 14px);
    font-family: PingFangTC-Regular, PingFangTC;
    font-weight: 400;
    color: #8b8b8b;
    line-height: calc($multiple * 36px);
    letter-spacing: 1px;
  }
  .main {
    padding-top: calc($multiple * 47px);
    .main-tips {
      height: calc($multiple * 43px);
      font-size: calc($multiple * 14px);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.57);
      line-height: calc($multiple * 43px);
      margin-top: calc($multiple * 47px);
    }
  }
  .circle {
    width: calc($multiple * 400px);
    height: calc($multiple * 382px);
    background:center center url("~assets/images/privacyProtect/manage-system.gif") no-repeat;
    background-size: 100%;
    position: absolute;
    top: calc($multiple * 65px);
    left: calc($multiple * 600px);
  }
}
.Manage-system-content-main-mobile {
  padding: 0 1.18rem;
  .headers {
    height: 3.4rem;
    font-size: 0.61rem;
    line-height: 1.13rem;
    letter-spacing: 0.05rem;
  }
  .main {
    .main-tips {
      font-size: 0.61rem;
      line-height: 1.13rem;
      margin-top: 1.24rem;
    }
  }
  .circle {
    width: 13.54rem;
    height: 14rem;
    position: absolute;
    left: 2.9rem;
    top: 20rem;
  }
}
</style>
